import { render, staticRenderFns } from "./vsSlider.vue?vue&type=template&id=3b87d2ec&lang=html&"
import script from "./vsSlider.vue?vue&type=script&lang=js&"
export * from "./vsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSlider.vue"
export default component.exports